module.exports = __webpack_public_path__ + "img/modal-document-create-fl.11d2b76e.svg";